module.exports = __webpack_public_path__ + "cf31f4788f7f32eeff58eff5184c99c7.png";